import { text } from "@fortawesome/fontawesome-svg-core";

export const phases_color_ramp = {
    "sowingplanting": { color: "#FF0000", textColor: "#FFFFFF" },
    "sprouting": {color: "#FF7F00", textColor: "#FFFFFF"},
    "bolting": {color: "#FFFF00", textColor: "#000000"},
    "blooming": {color: "#7FFF00", textColor: "#000000"},
    "maturation": {color: "#5FDA5F", textColor: "#000000"},
    "harvest": {color: "#009100", textColor: "#FFFFFF"},
  }

export const crop_phases = {
    "sowing/planting": {
        name: "Sowing/Planting",
        colors: phases_color_ramp["sowingplanting"],
        description: "The process of planting seeds or seedlings in the soil.",
    },
    "sprouting": {
        name: "Sprouting",
        colors: phases_color_ramp["sprouting"],
        description: "The stage where the seed begins to germinate and grow.",
    },
    "bolting": {
        name: "Bolting",
        colors: phases_color_ramp["bolting"],
        description: "The stage where the plant starts to flower and produce seeds.",
    },
    "blooming": {
        name: "Blooming",
        colors: phases_color_ramp["blooming"],
        description: "The stage where the plant produces flowers.",
    },
    "maturation": {
        name: "Maturation",
        colors: phases_color_ramp["maturation"],
        description: "The stage where the plant reaches its full size and readiness for harvest.",
    },
    "harvest": {
        name: "Harvest",
        colors: phases_color_ramp["harvest"],
        description: "The process of gathering mature crops from the fields.",
    },
}

// Helper to squash spaces / symbols → key in colour ramp
export const normPhase = (p) => (p ?? '').toString().toLowerCase().replace(/[^a-z]/g, '');

export const PHASE_ORDER = [
  'sowingplanting',
  'sprouting',
  'bolting',
  'blooming',
  'maturation',
  'harvest',
];
